import React from 'react';
import Candidat from './composant/Candidat';
import HeaderComposant from './composant/Headercomposant';
import Footer from './composant/Footer';

const CandidatePage = () => {
  return (
    <>
    <HeaderComposant />
    <Candidat />
    <Footer />
    </>
  );
};

export default CandidatePage;